import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncMarkerMap = asyncComponent({
    name: 'AsyncMarkerMap',
    resolve: () => import(
        /* webpackChunkName: "map" */
        /* webpackPrefetch: true */
        './MarkerMap'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
